import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, TooltipHost, Icon, TextField } from 'office-ui-fabric-react';
import {
  getRelId,
  getAttr,
  getEntityId,
} from '../../../../../features/helpers/apiHelpers';
import { optionsMapperName } from '../../../../../utilities/mapperFunctions';
import { useSelector } from 'react-redux';
import { validationRuleByFieldType } from '../../../../../features/apiFeatures/validationRuleSlice';
import { FIELDTYPE_ESDH_TITLE } from '../../../../../constants/api';
import { resolveValidationRules } from '../../../../../utilities/validationRuleHelper';

const textfieldStylesSbsys = {
  subComponentStyles: {
    label: {
      root: {
        fontSize: '14',
        fontWeight: '500',
        color: '#333333',
      },
    },
  },
};

const iconStyles = {
  root: {
    paddingLeft: '10px',
  },
};

const dropdownStylesSbsys = {
  root: { paddingTop: '20px', paddingBottom: '5px' },
  label: {
    fontSize: '14',
    fontWeight: '500',
    color: '#333333',
  },
};

const MetaDataEsdhTitle = ({
  updateHearingModelAttribute,
  hearingModel,
  hearingModelInCreatedStatus,
  esdhTemplates,
  selectedEsdhTemplateId,
  setSelectedEsdhTemplateId,
  showErrors,
}) => {
  const { t: translator } = useTranslation();

  const validationEntity = useSelector(
    validationRuleByFieldType(FIELDTYPE_ESDH_TITLE),
  );
  let { maxLength } = resolveValidationRules(validationEntity);

  const esdhTitle = getAttr(hearingModel, 'esdhTitle');
  const disableFields =
    !getRelId(hearingModel, 'hearingType') || !hearingModelInCreatedStatus;
  const disbaleTemplateDropdown =
    disableFields || (esdhTemplates && esdhTemplates.length === 0);

  const onChangeEsdhTitle = (_, value) => {
    const clampedValue = value && value.substring(0, maxLength);
    updateHearingModelAttribute('esdhTitle', clampedValue);
  };

  const onChangeEsdhTemplate = (_, value) => {
    const esdhTemplate = esdhTemplates.find(
      (e) => getEntityId(e) === value.key,
    );
    const esdhText = getAttr(esdhTemplate, 'text');
    updateHearingModelAttribute('esdhTitle', esdhText);
    setSelectedEsdhTemplateId(value.key);
  };

  return (
    <div>
      <Dropdown
        placeholder={translator('global.noneSelected')}
        label={
          <div className="create-hearing-title-with-icon">
            <span>{translator('hearingProperties.esdhTitle')}</span>
            <TooltipHost
              content={translator('pages.createHearing.esdhTemplateTooltip')}
            >
              <Icon iconName="Info" styles={iconStyles} />
            </TooltipHost>
          </div>
        }
        selectedKey={selectedEsdhTemplateId}
        onChange={onChangeEsdhTemplate}
        options={esdhTemplates && esdhTemplates.map(optionsMapperName)}
        styles={dropdownStylesSbsys}
        disabled={disbaleTemplateDropdown}
      />
      <TextField
        placeholder={translator('pages.createHearing.esdhTemplatePlaceholder')}
        value={esdhTitle}
        disabled={disableFields}
        onChange={onChangeEsdhTitle}
        styles={textfieldStylesSbsys}
        errorMessage={
          showErrors && !getAttr(hearingModel, 'esdhTitle')
            ? translator('global.requiredField')
            : null
        }
      />
      <div>
        <p className="field-limit-char-count-sbsys">
          {translator('global.noOfChars')} {esdhTitle ? esdhTitle.length : 0}/
          {maxLength}
        </p>
      </div>
    </div>
  );
};

export { MetaDataEsdhTitle };
